// src/services/storageService.js
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase";

export function uploadFile(file, path, onProgress) {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage, path);
    const task = uploadBytesResumable(storageRef, file);
    task.on("state_changed",
      snap => onProgress && onProgress(Math.round(snap.bytesTransferred / snap.totalBytes * 100)),
      reject,
      async () => resolve(await getDownloadURL(task.snapshot.ref))
    );
  });
}

export async function uploadFiles(files, basePath, onProgress) {
  const urls = [];
  for (let i = 0; i < files.length; i++) {
    const url = await uploadFile(files[i], `${basePath}/${Date.now()}_${i}`, p => onProgress && onProgress(i, p));
    urls.push(url);
  }
  return urls;
}
